import { OZ } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StretchedGridItem = styled(UIGridItem).withConfig({
  displayName: "Tx120FeatureRow__StretchedGridItem",
  componentId: "sc-1ferkn6-0"
})(["padding:0 10px !important;> div{height:100%;}"]);
const Tx120FeatureRow = ({
  className,
  survey,
  isOtherSelected,
  featureKeys,
  onSelectionChange,
  offset = false
}) => {
  return /*#__PURE__*/_jsx(UIGrid, {
    className: className,
    children: featureKeys.map(featureKey => {
      const isSelected = featureKey === 'other' ? isOtherSelected : survey[featureKey];
      return /*#__PURE__*/_jsx(StretchedGridItem, {
        size: 4,
        offset: offset ? 4 : 0,
        children: /*#__PURE__*/_jsx(UISelectableButton, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.trialFeatureSurvey.common.features.${featureKey}`
          }),
          selected: isSelected,
          onSelectedChange: evt => onSelectionChange(featureKey, evt.target.value),
          children: isSelected && /*#__PURE__*/_jsx(UIIcon, {
            name: "success",
            color: OZ,
            size: "xxs"
          })
        })
      }, featureKey);
    })
  });
};
export default Tx120FeatureRow;